import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EExternalSource } from './external-sources';
import { EModel } from './model';
export let EUploadStatus;
(function (EUploadStatus) {
  EUploadStatus["Unmapped"] = "unmapped";
  EUploadStatus["Pending"] = "pending";
  EUploadStatus["Processing"] = "processing";
  EUploadStatus["Completed"] = "completed";
  EUploadStatus["Failed"] = "failed";
})(EUploadStatus || (EUploadStatus = {}));
export let EUploadType;
(function (EUploadType) {
  EUploadType["Appointment"] = "appointment";
  EUploadType["AppointmentNoSync"] = "appointment-no-sync";
  EUploadType["Availability"] = "availability";
  EUploadType["Patient"] = "patient";
  EUploadType["Referral"] = "referral";
  EUploadType["Recall"] = "recall";
  EUploadType["Waitlist"] = "waitlist";
})(EUploadType || (EUploadType = {}));
export let EUploadContentStorage;
(function (EUploadContentStorage) {
  EUploadContentStorage["Mongo"] = "mongo";
  EUploadContentStorage["FileUpload"] = "file-upload";
})(EUploadContentStorage || (EUploadContentStorage = {}));
export const fieldsUpload = _extends({}, fieldsIBaseModelWithUser, {
  content: {
    type: 'Unknown'
  },
  contentStorage: {
    type: 'Option',
    values: EUploadContentStorage
  },
  filename: {
    type: 'Text'
  },
  fileUpload: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  incrRecordsCreated: {
    type: 'Number'
  },
  incrRecordsSkipped: {
    type: 'Number'
  },
  integrator: {
    type: 'Option',
    values: EExternalSource
  },
  mapping: {
    type: 'ID',
    ref: EModel.FileMapping
  },
  results: {
    type: 'Object'
  },
  resultsDescription: {
    type: 'Text'
  },
  sftp: {
    type: 'Boolean'
  },
  stats: {
    type: 'Object'
  },
  status: {
    type: 'Option',
    values: EUploadStatus
  },
  totalPatients: {
    type: 'Number'
  },
  type: {
    type: 'Option',
    values: EUploadType
  }
});